import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// Semua route produk redirect ke login (LMS STIKSAM)
const productRoutes = [
  <Route key="bootcamp" exact path="/bootcamp" render={() => <Redirect to="/login" />} />,
  <Route key="buku-online" exact path="/buku-online" render={() => <Redirect to="/login" />} />,
  <Route key="masukapoteker" exact path="/masukapoteker" render={() => <Redirect to="/login" />} />,
  <Route key="ukmppai" exact path="/ukmppai" render={() => <Redirect to="/login" />} />,
  <Route key="ukomttk" exact path="/ukomttk" render={() => <Redirect to="/login" />} />,
  <Route key="tryout" exact path="/tryout" render={() => <Redirect to="/login" />} />,
  <Route key="buku" exact path="/buku" render={() => <Redirect to="/login" />} />,
  <Route key="beasiswa-obatukai" exact path="/beasiswa-obatukai" render={() => <Redirect to="/login" />} />
];

export default productRoutes;
